export default __webpack_public_path__ + "static/media/bnk.0dacbc7d.png";